import React, { useMemo } from 'react';
import { calculateFinancials } from '../../services/financialCalculations';
import { formatCurrency, formatPercentage } from '../../utils/formatters';

const CapitalIrrSensitivityTable = ({ inputs }) => {
    const { sensitivityData, tariffRange, ownFundsRange } = useMemo(() => {
        const baseTariff = inputs.onGridTariff;
        const baseOwnFunds = inputs.ownFunds;

        const tariffRange = [-0.2, -0.1, 0, 0.1, 0.2].map(mod => baseTariff * (1 + mod));
        const ownFundsRange = [-0.2, -0.1, 0, 0.1, 0.2].map(mod => baseOwnFunds * (1 + mod));

        const sensitivityData = ownFundsRange.map(funds => {
            return tariffRange.map(tariff => {
                const tempInputs = { ...inputs, onGridTariff: tariff, ownFunds: funds };
                return calculateFinancials(tempInputs).indicators.capitalIRR;
            });
        });

        return { sensitivityData, tariffRange, ownFundsRange };
    }, [inputs]);

    return (
        <div className="mt-6">
            <h4 className="text-md font-semibold text-gray-800 dark:text-gray-100 mb-2">Capital IRR Sensitivity Analysis (Tariff vs. Own Funds)</h4>
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-center border-collapse border border-gray-300 dark:border-gray-600">
                    <thead className="bg-gray-100 dark:bg-gray-700">
                        <tr>
                            <th className="p-2 border border-gray-300 dark:border-gray-600">
                                <div className="flex flex-col items-center">
                                    <span className="font-bold">Own Funds ↓</span>
                                    <span className="font-normal text-xs">Tariff →</span>
                                </div>
                            </th>
                            {tariffRange.map((tariff, index) => (
                                <th key={index} className="p-2 border border-gray-300 dark:border-gray-600 font-medium">{formatCurrency(tariff, 3)}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {ownFundsRange.map((funds, rowIndex) => (
                            <tr key={rowIndex} className="hover:bg-gray-50 dark:hover:bg-gray-700/50">
                                <th className="p-2 border border-gray-300 dark:border-gray-600 font-medium bg-gray-100 dark:bg-gray-700">{formatCurrency(funds)}</th>
                                {sensitivityData[rowIndex].map((irr, colIndex) => {
                                    const isBaseCase = rowIndex === 2 && colIndex === 2;
                                    return (
                                        <td key={colIndex} className={`p-2 border border-gray-300 dark:border-gray-600 ${isBaseCase ? 'bg-blue-100 dark:bg-blue-900/50 font-bold' : ''}`}>
                                            {formatPercentage(irr)}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CapitalIrrSensitivityTable; 